<script setup lang="ts">
  import type { SharedOrder } from '@storefront/resources';

  interface Props {
    order?: SharedOrder;
  }

  defineProps<Props>();
</script>
<template>
  <AppWrapper>
    <CartLayoutHeader />
    <slot />
    <CartLayoutFooter :order="order" />
  </AppWrapper>
</template>